// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file timeline/toolbar/toolbar.proto (package wisetime.timeline.toolbar, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file timeline/toolbar/toolbar.proto.
 */
export const file_timeline_toolbar_toolbar: GenFile = /*@__PURE__*/
  fileDesc("Ch50aW1lbGluZS90b29sYmFyL3Rvb2xiYXIucHJvdG8SGXdpc2V0aW1lLnRpbWVsaW5lLnRvb2xiYXIi2QEKEFBlcnNpc3RlZFRvb2xiYXISQQoJc29ydF90eXBlGAEgASgOMi4ud2lzZXRpbWUudGltZWxpbmUudG9vbGJhci5UaW1lbGluZVJvd1NvcnRUeXBlEkIKCnNvcnRfb3JkZXIYAiABKA4yLi53aXNldGltZS50aW1lbGluZS50b29sYmFyLlRpbWVCbG9ja3NTb3J0T3JkZXISPgoKdmlld19mbGFncxgDIAMoDjIqLndpc2V0aW1lLnRpbWVsaW5lLnRvb2xiYXIuVGltZVJvd1ZpZXdGbGFnKnMKE1RpbWVsaW5lUm93U29ydFR5cGUSDgoKQ0hST05PTE9HWRAAEhYKElJFVkVSU0VfQ0hST05PTE9HWRABEgwKCERVUkFUSU9OEAISDAoIQUNUSVZJVFkQAxIPCgtERVNDUklQVElPThAEEgcKA1RBRxAFKjQKE1RpbWVCbG9ja3NTb3J0T3JkZXISDQoJQVNDRU5ESU5HEAASDgoKREVTQ0VORElORxABKjgKD1RpbWVSb3dWaWV3RmxhZxILCgdFUlJPUkVEEAASCgoGVEFHR0VEEAESDAoIVU5UQUdHRUQQAmIGcHJvdG8z");

/**
 * Message used to persist toolbar filters into local storage
 *
 * @generated from message wisetime.timeline.toolbar.PersistedToolbar
 */
export type PersistedToolbar = Message<"wisetime.timeline.toolbar.PersistedToolbar"> & {
  /**
   * @generated from field: wisetime.timeline.toolbar.TimelineRowSortType sort_type = 1;
   */
  sortType: TimelineRowSortType;

  /**
   * @generated from field: wisetime.timeline.toolbar.TimeBlocksSortOrder sort_order = 2;
   */
  sortOrder: TimeBlocksSortOrder;

  /**
   * @generated from field: repeated wisetime.timeline.toolbar.TimeRowViewFlag view_flags = 3;
   */
  viewFlags: TimeRowViewFlag[];
};

/**
 * Describes the message wisetime.timeline.toolbar.PersistedToolbar.
 * Use `create(PersistedToolbarSchema)` to create a new message.
 */
export const PersistedToolbarSchema: GenMessage<PersistedToolbar> = /*@__PURE__*/
  messageDesc(file_timeline_toolbar_toolbar, 0);

/**
 * @generated from enum wisetime.timeline.toolbar.TimelineRowSortType
 */
export enum TimelineRowSortType {
  /**
   * @generated from enum value: CHRONOLOGY = 0;
   */
  CHRONOLOGY = 0,

  /**
   * @generated from enum value: REVERSE_CHRONOLOGY = 1;
   */
  REVERSE_CHRONOLOGY = 1,

  /**
   * @generated from enum value: DURATION = 2;
   */
  DURATION = 2,

  /**
   * @generated from enum value: ACTIVITY = 3;
   */
  ACTIVITY = 3,

  /**
   * @generated from enum value: DESCRIPTION = 4;
   */
  DESCRIPTION = 4,

  /**
   * @generated from enum value: TAG = 5;
   */
  TAG = 5,
}

/**
 * Describes the enum wisetime.timeline.toolbar.TimelineRowSortType.
 */
export const TimelineRowSortTypeSchema: GenEnum<TimelineRowSortType> = /*@__PURE__*/
  enumDesc(file_timeline_toolbar_toolbar, 0);

/**
 * @generated from enum wisetime.timeline.toolbar.TimeBlocksSortOrder
 */
export enum TimeBlocksSortOrder {
  /**
   * @generated from enum value: ASCENDING = 0;
   */
  ASCENDING = 0,

  /**
   * @generated from enum value: DESCENDING = 1;
   */
  DESCENDING = 1,
}

/**
 * Describes the enum wisetime.timeline.toolbar.TimeBlocksSortOrder.
 */
export const TimeBlocksSortOrderSchema: GenEnum<TimeBlocksSortOrder> = /*@__PURE__*/
  enumDesc(file_timeline_toolbar_toolbar, 1);

/**
 * @generated from enum wisetime.timeline.toolbar.TimeRowViewFlag
 */
export enum TimeRowViewFlag {
  /**
   * With errorMessage from validation or backend, filtered via the time posting error pane
   *
   * @generated from enum value: ERRORED = 0;
   */
  ERRORED = 0,

  /**
   * Toolbar filter
   *
   * @generated from enum value: TAGGED = 1;
   */
  TAGGED = 1,

  /**
   * @generated from enum value: UNTAGGED = 2;
   */
  UNTAGGED = 2,
}

/**
 * Describes the enum wisetime.timeline.toolbar.TimeRowViewFlag.
 */
export const TimeRowViewFlagSchema: GenEnum<TimeRowViewFlag> = /*@__PURE__*/
  enumDesc(file_timeline_toolbar_toolbar, 2);

